import React from 'react';
import {
  AlertIcon,
  ShieldCheckIcon,
  ShieldXIcon,
  SpinnerIcon
} from './StatusIcons';

function getScanBadgeModel(tone) {
  if (tone === 'clean') {
    return {
      tone: 'accepted',
      label: 'File Accepted',
      icon: <ShieldCheckIcon title="File Accepted" />
    };
  }

  if (tone === 'quarantine') {
    return {
      tone: 'rejected',
      label: 'File Rejected',
      icon: <ShieldXIcon title="File Rejected" />
    };
  }

  if (tone === 'failed') {
    return {
      tone: 'rejected',
      label: 'Error In Upload',
      icon: <AlertIcon title="Error In Upload" />
    };
  }

  if (tone === 'scan') {
    return {
      tone: 'scanning',
      label: 'Scanning In Progress',
      icon: <SpinnerIcon title="Scanning In Progress" />
    };
  }

  return null;
}

export function ScanStatusBadge({ tone }) {
  const badge = getScanBadgeModel(tone);
  if (!badge) {
    return null;
  }

  return (
    <div className={`scan-status-badge scan-status-badge-${badge.tone}`} role="status" aria-live="polite">
      <span className="scan-status-badge-label">{badge.label}</span>
      <span className="scan-status-badge-icon" aria-hidden="true">{badge.icon}</span>
    </div>
  );
}
